import React from "react";

/**
 * Pagination - Componente de paginación reutilizable
 * 
 * @param {Object} value - Objeto con page, size, total
 * @param {Function} onChange - Callback al cambiar paginación
 * @param {Boolean} showSizeSelector - Mostrar selector de tamaño
 * @param {Boolean} disabled - Deshabilitar controles
 */
const Pagination = ({
    value,
    onChange,
    showSizeSelector = true,
    disabled = false
}) => {
    const { page = 0, size = 10, total = 0 } = value || {};
    const totalPages = Math.ceil(total / size);

    const handlePrevious = () => {
        if (page > 0 && !disabled) {
            onChange({ ...value, page: page - 1 });
        }
    };

    const handleNext = () => {
        if (page + 1 < totalPages && !disabled) {
            onChange({ ...value, page: page + 1 });
        }
    };

    const handleSizeChange = (e) => {
        if (!disabled) {
            onChange({ ...value, size: parseInt(e.target.value), page: 0 });
        }
    };

    if (total === 0) {
        return null;
    }

    return (
        <div style={styles.container}>
            <button
                style={{
                    ...styles.button,
                    backgroundColor: page === 0 || disabled ? "#ccc" : "#00468B",
                    cursor: page === 0 || disabled ? "not-allowed" : "pointer",
                }}
                disabled={page === 0 || disabled}
                onClick={handlePrevious}
            >
                ← Anterior
            </button>

            <span style={styles.pageInfo}>
                Página {page + 1} de {totalPages || 1}
            </span>

            <button
                style={{
                    ...styles.button,
                    backgroundColor: (page + 1) >= totalPages || disabled ? "#ccc" : "#00468B",
                    cursor: (page + 1) >= totalPages || disabled ? "not-allowed" : "pointer",
                }}
                disabled={(page + 1) >= totalPages || disabled}
                onClick={handleNext}
            >
                Siguiente →
            </button>

            {showSizeSelector && (
                <select
                    value={size}
                    onChange={handleSizeChange}
                    style={styles.sizeSelector}
                    disabled={disabled}
                >
                    {[5, 10, 20, 50].map((s) => (
                        <option key={s} value={s}>
                            {s} por página
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

const styles = {
    container: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        padding: "10px",
    },
    button: {
        padding: "8px 16px",
        borderRadius: "6px",
        border: "none",
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
        transition: "background-color 0.2s",
    },
    pageInfo: {
        color: "#00468B",
        fontWeight: "bold",
        fontSize: "14px",
    },
    sizeSelector: {
        marginLeft: "20px",
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        fontSize: "14px",
        cursor: "pointer",
    },
};

export default Pagination;
